import Quill from 'quill';

const Module = Quill.import('core/module');

class CustomAlignModule extends Module {
    constructor(quill: any, options: any) {
      super(quill, options);
      const toolbar = quill.getModule('toolbar');
      if (toolbar) {
        toolbar.addHandler('align', this.toggleAlign.bind(this, quill));
      }
    }

    toggleAlign(quill: any, value: string) {
      const range = quill.getSelection();
      if (!range) return;

      const newAlign = value || 'left'; // Default to 'left' if no value is provided

      // Apply alignment to each line in the selection
      const [startLine, startOffset] = quill.getLine(range.index);
      const [endLine, endOffset] = quill.getLine(range.index + range.length);

      let line = startLine;
      while (line) {
        const node = line.domNode;
        this.applyAlignment(node, newAlign);

        if (line === endLine) break;
        line = line.nextSibling;
      }

      // Apply formatting to the selection range
      quill.format('align', newAlign, Quill.sources.USER);
    }

    private applyAlignment(node: HTMLElement, align: string) {
      node.classList.remove('ql-align-left', 'ql-align-center', 'ql-align-right', 'ql-align-justify');
      node.style.textAlign = align;
      node.classList.add(`ql-align-${align}`);
    }
}

// Register the custom alignment module
Quill.register('modules/customAlignModule', CustomAlignModule, true);

export default CustomAlignModule;
